import { render, staticRenderFns } from "./KategoriListe.vue?vue&type=template&id=20feb6fc&scoped=true&"
import script from "./KategoriListe.vue?vue&type=script&lang=js&"
export * from "./KategoriListe.vue?vue&type=script&lang=js&"
import style0 from "./KategoriListe.vue?vue&type=style&index=0&id=20feb6fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20feb6fc",
  null
  
)

export default component.exports